//  Application imports
import { RAccountDetails } from './account-details.record';
import { RMainMenuItem, RSubMenuItem } from './menu-item.record';
import { Utils } from 'app/utils';
//  Third party imports
import { deserialize, deserializeAs } from 'cerialize';

/* eslint-disable  @typescript-eslint/no-unused-vars */

export class RAccount {

    public static OnDeserialized(instance: RAccount, _: unknown): void {
        instance.serviceMenu.sort(Utils.sortByOrder);
        instance.supportMenu.sort(Utils.sortByOrder);
        instance.userMenu.sort(Utils.sortByOrder);
    }

    @deserializeAs(RAccountDetails)
    public details: RAccountDetails;
    @deserialize
    public logo: string;
    @deserializeAs(RMainMenuItem)
    public serviceMenu: Array<RMainMenuItem>;
    @deserializeAs(RMainMenuItem)
    public supportMenu: Array<RMainMenuItem>;
    @deserializeAs(RSubMenuItem)
    public userMenu: Array<RSubMenuItem>;

    // for simplicity checks
    public get serviceHasItems(): boolean {
        if (this.serviceMenu === null)
            return false;

        return this.serviceMenu[0]?.hasItems ||
            this.serviceMenu[1]?.hasItems ||
            this.serviceMenu[2]?.hasItems || false;
    }

    public get supportHasItems(): boolean {
        if (this.supportMenu === null)
            return false;

        return this.supportMenu[0]?.hasItems ||
            this.supportMenu[1]?.hasItems ||
            this.supportMenu[2]?.hasItems ||
            this.supportMenu[3]?.hasItems || false;
    }
}
